;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"b2b361d9b58bd97488dc7d14f7e00e641c4840dd"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.SENTRY_DNS,
    environment: process.env.SENTRY_ENV || "production",
    denyUrls: [
      /@next\/third-parties\/dist\/google\/gtm\.js/i, // Next 3P GTM bundle
      /googletagmanager\.com/i,
      /gtm\.js/i,
      /google-analytics\.com/i,
    ],
    // Fast drop: known harmless error messages (browser-y network noise)
    ignoreErrors: [
      /TypeError:\s*Load failed/i,
      /Load failed/i,
      /NetworkError/i,
      /Failed to fetch/i,
      /Error invoking post:\s*Method not found/i,
    ],

    beforeSend(event: any) {
      // If there are exception values, inspect frames
      const values = event.exception?.values ?? [];
      const frames = values.flatMap((v: any) => v.stacktrace?.frames ?? []);
      const hasInApp = frames.some((f: any) => f.in_app === true);

      // Some Next.js internal noise: occasionally shows up as an error message
      const msg = event.message || values.map((v: any) => v.value).join(" | ");

      if (/incomplete-app-router-transaction/i.test(msg)) return null;

      if (!hasInApp) return null; // drop purely non-app stacks
      return event;
    },

    // Drop noisy performance transactions from the App Router
    beforeSendTransaction(event: any) {
      if (event.transaction === "incomplete-app-router-transaction") {
        return null;
      }
      return event;
    },

    integrations: [
      Sentry.replayIntegration({
        maskAllText: true, // Hides PII text — unmask specific elements intentionally
        blockAllMedia: true, // Hides images/video
      }),
    ],
    // Session Replay
    replaysSessionSampleRate: 0.0, // Normal sessions not sampled; increase if you want baseline replays.
    replaysOnErrorSampleRate: 1.0, // Capture replay for all sessions where an error occurs.
    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 0.1,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
  });
}
